import { FocusEvent } from 'react';

export const isUndoOrRedoButtonClicked = (
  event: FocusEvent<HTMLInputElement | HTMLTextAreaElement> | MouseEvent
): boolean => {
  const buttonTarget = (event as MouseEvent).target as HTMLButtonElement;
  const buttonTargetAriaLabel = buttonTarget.getAttribute('aria-label');

  if (buttonTargetAriaLabel === 'Undo' || buttonTargetAriaLabel === 'Redo') {
    return true;
  }

  const { relatedTarget } = event as FocusEvent<HTMLInputElement | HTMLTextAreaElement>;

  if (relatedTarget === null) {
    return false;
  }

  const isRedoButtonClicked = isButton(relatedTarget) && relatedTarget.getAttribute('aria-label') === 'Redo';

  return isUndoButtonClicked(event as FocusEvent<HTMLInputElement | HTMLTextAreaElement>) || isRedoButtonClicked;
};

export const isUndoButtonClicked = (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>): boolean => {
  const { relatedTarget } = event;

  return relatedTarget !== null && isButton(relatedTarget) && relatedTarget.getAttribute('aria-label') === 'Undo';
};

const isButton = (relatedTarget: EventTarget & Element): boolean => {
  return relatedTarget.nodeName === 'BUTTON';
};
